import React from "react";
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { theme as themeConfig } from "../../themes/themes";
import { ContentField } from "./RenderInputsComponent.style";

const customStyles = {
  control: (base, state) => ({
    ...base,
    boxShadow: "none",
    borderColor: themeConfig.primary.icon,
    // You can also use state.isFocused to conditionally style based on the focus state
    "&:hover": {
      borderColor: themeConfig.primary.blue,
      boxShadow: `0 0 0 0.2rem ${themeConfig.primary.blue}40`,
    },
  }),
};

const RenderInputsComponent = ({ fields }) => {
  const renderInputs = (obj, index) => {
    switch (obj.type) {
      case "select":
        return (
          <ContentField key={index}>
            <Form.Label style={{ color: themeConfig.primary.icon }}>
              {obj.label}
              {obj.mandatory && <span style={{ color: themeConfig.primary.redLight }}> *</span>}
            </Form.Label>{" "}
            <Select
              styles={customStyles}
              placeholder={obj.placeholder}
              ref={obj.ref}
              isMulti={obj.isMulti}
              isDisabled={obj.isDisabled}
              options={obj.data}
              onChange={() => obj.fn()}
            />
            {obj.ref.current &&
              obj.ref.current.state.ariaSelection?.value != null &&
              (!obj.isMulti ||
                (obj.isMulti &&
                  obj.ref.current.state.selectValue.length > 0)) && (
                <CheckIcon
                  style={{
                    color: themeConfig.neutral.white,
                    background: themeConfig.primary.green,
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
          </ContentField>
        );
      case "text":
      case "date":
      case "datetime-local":
      case "time":
      case "number":
      case "textarea":
        return (
          <ContentField
            key={index}
            style={{ gridColumn: obj.type == "textarea" ? "1/4" : "" }}
          >
            <Form.Label style={{ color: themeConfig.primary.icon }}>
              {obj.label}
              {obj.mandatory && <span style={{ color: themeConfig.primary.redLight }}> *</span>}
            </Form.Label>{" "}
            {obj.type == "textarea" && (
              <Form.Control
                as="textarea"
                rows={5}
                ref={obj.ref}
                placeholder={obj.placeholder}
                onChange={() => (obj.label == "Email" ? obj.fn(obj) : obj.fn())}
              />
            )}
            {obj.type == "text" && (
              <Form.Control
                type="text"
                ref={obj.ref}
                readOnly={obj.isDisabled}
                placeholder={obj.placeholder}
                onChange={() => (obj.label == "Email" ? obj.fn(obj) : obj.fn())}
              />
            )}
            {obj.type == "date" && (
              <Form.Control
                type="date"
                ref={obj.ref}
                readOnly={obj.isDisabled}
                placeholder={obj.placeholder}
                onChange={() => (obj.label == "Email" ? obj.fn(obj) : obj.fn())}
              />
            )}
            {obj.type == "datetime-local" && (
              <Form.Control
                type="datetime-local"
                ref={obj.ref}
                readOnly={obj.isDisabled}
                placeholder={obj.placeholder}
                onChange={() => (obj.label == "Email" ? obj.fn(obj) : obj.fn())}
              />
            )}
            {obj.type == "time" && (
              <Form.Control
                type="time"
                ref={obj.ref}
                readOnly={obj.isDisabled}
                placeholder={obj.placeholder}
                onChange={() => (obj.label == "Email" ? obj.fn(obj) : obj.fn())}
              />
            )}
            {obj.type == "number" && (
              <Form.Control
                type="number"
                ref={obj.ref}
                pattern="[0-9]+"
                readOnly={obj.isDisabled}
                placeholder={obj.placeholder}
                onChange={() => (obj.label == "Email" ? obj.fn(obj) : obj.fn())}
              />
            )}
            {obj.ref.current &&
              obj.ref.current.value &&
              obj.regexp &&
              ((obj.label === "Email" &&
                obj.regexp.test(obj.ref.current.value)) ||
                (obj.label !== "Email" &&
                  !obj.regexp.test(obj.ref.current.value))) && (
                <CheckIcon
                  style={{
                    color: themeConfig.neutral.white,
                    background: themeConfig.primary.green,
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
            {obj.ref.current && obj.ref.current.value && !obj.regexp && (
              <CheckIcon
                style={{
                  color: themeConfig.neutral.white,
                  background: themeConfig.primary.green,
                  borderRadius: "36px",
                  fontSize: "13px",
                  margin: "0px 3px",
                }}
              />
            )}
            {obj.ref.current &&
              obj.ref.current.value &&
              obj.regexp &&
              ((obj.label !== "Email" &&
                obj.regexp.test(obj.ref.current.value)) ||
                (obj.label === "Email" &&
                  !obj.regexp.test(obj.ref.current.value))) && (
                <CloseIcon
                  style={{
                    color: themeConfig.neutral.white,
                    background: themeConfig.status.error,
                    borderRadius: "36px",
                    fontSize: "13px",
                    margin: "0px 3px",
                  }}
                />
              )}
          </ContentField>
        );
      default:
        break;
    }
  };
  return <>{fields.map((f, index) => renderInputs(f, index))}</>;
};
export default RenderInputsComponent;
